var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "overlay", staticClass: "rb-full-screen-overlay-wrapper" },
    [
      !_vm.isMobile
        ? _c("div", { staticClass: "rb-full-screen-overlay-desk" }, [
            _vm.isProductMeta
              ? _c("div", { staticClass: "rb-full-screen-overlay" }, [
                  _c(
                    "div",
                    { staticClass: "glasses" },
                    [
                      _c("rb-dummy-skeleton", {
                        staticClass: "glasses--image-skeleton",
                        attrs: { icon: "assets" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "glasses--two" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--size-skeleton",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "options" }, [
                    _c(
                      "div",
                      { staticClass: "options--first-flex" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--loading-line",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--close-button",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--second-flex" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--frame-title",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--frame-price",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--third-flex" },
                      [
                        _c(
                          "div",
                          { staticClass: "--frames-boxes" },
                          [
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--bridge-tooltip",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--fourth-flex" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--lenses-price",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--prescription-pills",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "options--fifth-flex" }, [
                      _c(
                        "div",
                        { staticClass: "--lenses-pills" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-pills__sun",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-pills__filter",
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "--lenses-boxes" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "options--sixth-flex" }, [
                      _c(
                        "div",
                        { staticClass: "--footer-info" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--footer-info__title",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--footer-info__price",
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "--footer-ctas" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--footer-ctas__insurance",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--footer-ctas__addtobag",
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isProductMeta
              ? _c("div", { staticClass: "rb-full-screen-overlay" }, [
                  _c(
                    "div",
                    { staticClass: "glasses" },
                    [
                      _c("rb-dummy-skeleton", {
                        staticClass: "glasses--image-skeleton",
                        attrs: { icon: "assets" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "glasses--two" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--size-skeleton",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "options" }, [
                    _c(
                      "div",
                      { staticClass: "options--first-flex" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--loading-line",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--close-button",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--second-flex" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--frame-title",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--frame-price",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--prescription" },
                      [
                        _c("div", { staticClass: "--visions" }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--visions__method",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--visions__method",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--visions__method",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--visions__method",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--sixth-flex__eyeglass" },
                      [
                        _c(
                          "div",
                          { staticClass: "--footer-ctas__eyeglass" },
                          [
                            _c("rb-dummy-skeleton", {
                              staticClass: "--footer-ctas__insurance",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--footer-ctas__addtobag",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? _c("div", { staticClass: "rb-full-screen-overlay-mobile" }, [
            _vm.isProductMeta
              ? _c("div", { staticClass: "rb-full-screen-overlay" }, [
                  _c(
                    "div",
                    { staticClass: "glasses" },
                    [
                      _c("rb-dummy-skeleton", {
                        staticClass: "glasses--image-skeleton",
                        attrs: { icon: "assets" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "glasses--two" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--size-skeleton",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "options" }, [
                    _c(
                      "div",
                      { staticClass: "options--first-flex__meta" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--loading-line",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--close-button",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--second-flex__meta" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--frame-title",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--frame-price",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--third-flex" },
                      [
                        _c(
                          "div",
                          { staticClass: "--frames-boxes" },
                          [
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--frames-boxes__box",
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--bridge-tooltip",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--fourth-flex__meta" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--lenses-price",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--prescription-pills",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "options--fifth-flex" }, [
                      _c(
                        "div",
                        { staticClass: "--lenses-pills" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-pills__sun",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-pills__filter",
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "--lenses-boxes" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--lenses-boxes__box",
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "options--sixth-flex" }, [
                      _c(
                        "div",
                        { staticClass: "--footer-info__meta" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--footer-info__title",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--footer-info__price",
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "--footer-ctas__electronics" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--footer-ctas__insurance",
                          }),
                          _vm._v(" "),
                          _c("rb-dummy-skeleton", {
                            staticClass: "--footer-ctas__addtobag",
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isProductMeta
              ? _c("div", { staticClass: "rb-full-screen-overlay" }, [
                  _c(
                    "div",
                    { staticClass: "glasses__hide" },
                    [
                      _c("rb-dummy-skeleton", {
                        staticClass: "glasses--image-skeleton",
                        attrs: { icon: "assets" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "glasses--two" },
                        [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--size-skeleton",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "options" }, [
                    _c(
                      "div",
                      { staticClass: "options--first-flex" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--loading-line",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--close-button",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--second-flex" },
                      [
                        _c("rb-dummy-skeleton", {
                          staticClass: "--frame-title",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--frame-price",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--prescription" },
                      [
                        _c("div", { staticClass: "--visions" }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--visions__method",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--visions__method",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--visions__method",
                        }),
                        _vm._v(" "),
                        _c("rb-dummy-skeleton", {
                          staticClass: "--visions__method",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options--sixth-flex__eyeglass" },
                      [
                        _c(
                          "div",
                          { staticClass: "--footer-ctas__eyeglass" },
                          [
                            _c("rb-dummy-skeleton", {
                              staticClass: "--footer-ctas__insurance",
                            }),
                            _vm._v(" "),
                            _c("rb-dummy-skeleton", {
                              staticClass: "--footer-ctas__addtobag",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }